import {
  FirmwareManagerActions,
  FirmwareManagementActionTypes,
} from './firmware-manager.actions';
import { FirmwareManagementStateInterface } from './firmware-manager.model';


export const FirmwareManagementInitialState: FirmwareManagementStateInterface = {
  page: 1,
  pageCount: 1,
  itemCount: 1,
  itemTotal: 1,
  errors: [],
  filters: null,
  getFirmwaresLoading: false,
  getFirmwaresLoaded: false,
  getFirmwareLoading: false,
  getFirmwareLoaded: false,
  createFirmwareLoading: false,
  createFirmwareCompleted: false,
  updateFirmwareLoading: false,
  updateFirmwareCompleted: false,
  deleteFirmwareLoading: false,
  deleteFirmwareCompleted: false,
  uploadFirmwareLoading: false,
  uploadFirmwareCompleted: false,
  firmwares: [],
  firmware: null,
};

export function firmwareManagerReducer(state = FirmwareManagementInitialState, action: FirmwareManagerActions): FirmwareManagementStateInterface {
  switch (action.type) {
    case FirmwareManagementActionTypes.GetFirmwares:
      return {
        ...state,
        getFirmwaresLoading: true,
        getFirmwaresLoaded: false,
      };
    case FirmwareManagementActionTypes.GetFirmwaresCompleted:
      return {
        ...state,
        getFirmwaresLoading: false,
        getFirmwaresLoaded: true,
        firmwares: action.firmwaresList,
        itemTotal: action.itemTotal,
      };

    case FirmwareManagementActionTypes.GetFirmware:
      return {
        ...state,
        getFirmwareLoading: true,
        getFirmwareLoaded: false,
      };
    case FirmwareManagementActionTypes.GetFirmwareCompleted:
      return {
        ...state,
        getFirmwareLoading: false,
        getFirmwareLoaded: true,
        firmware: action.firmware.data,
      };
    case FirmwareManagementActionTypes.CreateFirmware:
      return {
        ...state,
        createFirmwareLoading: true,
        createFirmwareCompleted: false,
      };
    case FirmwareManagementActionTypes.CreateFirmwareCompleted:
      return {
        ...state,
        createFirmwareLoading: false,
        createFirmwareCompleted: true,
      };
    case FirmwareManagementActionTypes.UpdateFirmware:
      return {
        ...state,
        updateFirmwareLoading: true,
        updateFirmwareCompleted: false,
      };
    case FirmwareManagementActionTypes.UpdateFirmwareCompleted:
      return {
        ...state,
        updateFirmwareLoading: false,
        updateFirmwareCompleted: true,
      };

    case FirmwareManagementActionTypes.DeleteFirmware:
      return {
        ...state,
        deleteFirmwareLoading: true,
        deleteFirmwareCompleted: false,
      };
    case FirmwareManagementActionTypes.DeleteFirmwareCompleted:
      return {
        ...state,
        deleteFirmwareLoading: false,
        deleteFirmwareCompleted: true,
      };

    case FirmwareManagementActionTypes.UploadFirmware:
      return {
        ...state,
        uploadFirmwareLoading: true,
        uploadFirmwareCompleted: false,
      };
    case FirmwareManagementActionTypes.UploadFirmwareCompleted:
      return {
        ...state,
        uploadFirmwareLoading: false,
        uploadFirmwareCompleted: true,
      };

    case FirmwareManagementActionTypes.ClearState:
      return { ...FirmwareManagementInitialState };

    case FirmwareManagementActionTypes.FetchError:
      return {
        ...state,
        errors: action.payload,
      };

    default:
      return state;
  }
}
